import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';

@Component({
  selector: 'wsb-grid-icon-renderer',
  template: `
    <img class="iconrenderer" [src]="icon" /><span>{{ label | translate }}</span
    ><span *ngIf="asterix">&nbsp;*</span>
  `,
  standalone: false
})
export class AtlasGridIconRendererComponent implements ICellRendererAngularComp {
  params;
  icon: string;
  label: string;
  asterix: boolean;

  agInit(params): void {
    this.params = params;
    this.icon = this.params.icon;
    this.label = this.params.label;
    this.asterix = this.params?.asterix;
  }

  refresh(params?: any): boolean {
    return true;
  }
}
